import { render, staticRenderFns } from "./ModalOrderNotes.vue?vue&type=template&id=91e9b402&scoped=true"
import script from "./ModalOrderNotes.vue?vue&type=script&lang=js"
export * from "./ModalOrderNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e9b402",
  null
  
)

export default component.exports